import {UsersBackendUtils} from "@/modules/mprofiles/database/UsersBackendUtils";

export class MultipleSnapshotsUploader {

    constructor(shapshots, targetFolder) {
        this._shapshots = shapshots;
        this._targetFolder = targetFolder;
        this._checked = [];
        this._onComplete = null;
        this._onProgress = null;
    }

    setOnComplete(value){
        this._onComplete = value;
    }

    setOnProgress(value){
        this._onProgress = value;
    }

    init(){
        let item = this._shapshots.find(e => !this._checked.includes(e.id));
        if (item != null){
            this.next(item);
        }else{
            if (this._onComplete){
                this._onComplete(0);
            }
        }
    }
    next(shapshot){
        UsersBackendUtils.createUserSnapshot(shapshot.data)
        .then((response) => {
            let shapId = JSON.parse(response)["sid"];
            let data = {to_folder_id: this._targetFolder, snapshotId:[shapId]}
            UsersBackendUtils.moveSnapshotToFolder(data).then(() => {
                console.log("succes moved: ", shapId)
            }).catch((error) => {
                console.log("fail move: ", error, shapId)
            }).finally(() => {
                this._checked.push(shapshot.id);
                this.updateProgress();
                this.init();
            })
        }).catch((error) => {
            console.log("fail create shapshot: ", error, shapshot.id)
            this._checked.push(shapshot.id);
            this.updateProgress();
            this.init();
        })
    }

    updateProgress(){
        if (this._onProgress){
            this._onProgress(this._checked.length/this._shapshots.length);
        }
    }
}